export default [
  {
    name: 'ApiLimits',
    path: '/api-limits',
    component: () => import('./pages/ApiLimits'),
    meta: {
      ability: [
        {
          resource: 'api-limits',
          actions: ['read'],
        },
      ],
    },
  },
  {
    name: 'Add ApiLimit',
    path: '/api-limits/add',
    component: () => import('./pages/ApiLimitsDetails'),
    meta: {
      ability: [
        {
          resource: 'api-limits',
          actions: ['create'],
        },
      ],
    },
  },
  {
    name: 'Edit ApiLimit',
    path: '/api-limits/edit/:id',
    component: () => import('./pages/ApiLimitsDetails'),
    meta: {
      ability: [
        {
          resource: 'api-limits/:id',
          actions: ['update'],
        },
      ],
    },
    props: {
      editMode: true,
    },
  },
]
